import { BaseAlgorithmTuner } from './BaseTuner';
import * as DT from '../DataTypes';
import type * as THREE from 'three';
import type { PlanningAlgorithm } from '@/engine/PlanningAlgorithm/PlanningAlgorithm';

export class PointTuner extends BaseAlgorithmTuner<THREE.Vector3, DT.Point> {
  public constructor(planningAlgorithm: PlanningAlgorithm) {
    super(planningAlgorithm, DT.Point);
  }
}
